'use client';

import { Header } from '@/app/components/shared/Header';
import { useIsAiVideoEditorRoute } from './use-ai-video-editor-route';

export function WorkspaceRouteHeader() {
  const isAiVideoEditorRoute = useIsAiVideoEditorRoute();

  if (isAiVideoEditorRoute) {
    return null;
  }

  return <Header className="shrink-0" />;
}
